import { render, staticRenderFns } from "./Suger.vue?vue&type=template&id=172d2f07&scoped=true&"
import script from "./Suger.vue?vue&type=script&lang=js&"
export * from "./Suger.vue?vue&type=script&lang=js&"
import style1 from "./Suger.vue?vue&type=style&index=1&id=172d2f07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d2f07",
  null
  
)

export default component.exports